import { type PartnerConnection, PartnerConnectionStatus } from './redux/types';

// Ideally this functionality should be available in the backend, but it is currently not.

export const canPartnerConnectionBeDeleted = (item: PartnerConnection): boolean =>
    item.status === PartnerConnectionStatus.ACTIVATED || item.status === PartnerConnectionStatus.FAILED_DEACTIVATION;
